import React from 'react';
import { withRouter } from 'react-router-dom';
import { reset } from '@hobs/auth/actions';
import { withTranslation } from 'react-i18next';
import Toast from '@hobs/components/Toast';
import ResetForm from '@hobs/auth/components/ResetForm';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { getLoginImage } from '@hobs/utils/customLogoResolver';

import './Reset.scss';

class Reset extends React.PureComponent {
  static propTypes = {
    reset: propTypes.func,
    history: propTypes.object,
    t: propTypes.func,
    match: propTypes.object
  };

  state = {
    logoSrc: null
  };

  async submit(values) {
    const {
      t,
      match: { params },
      reset
    } = this.props;

    const results = await reset(
      params.userId,
      params.token,
      values.password,
      values.confirmPassword
    );

    if (results.success) {
      Toast.success(
        t(
          'Password was changed successfully, now you can login using your user name and newly created password'
        )
      );

      return this.props.history.push('/login');
    }

    return results;
  }

  componentDidMount() {
    this.getLoginImage();
  }

  getLoginImage = () => {
    getLoginImage().then(result => {
      if (!result) {
        this.setState({
          logoSrc: require('../../assets/images/ndlo-logo.png')
        });
        return;
      }

      this.setState({ logoSrc: result });
    });
  };

  render() {
    const { t } = this.props;

    return (
      <div className="reset">
        <div className="reset--left">HOBS</div>
        <div className="reset--right">
          <div className="reset--right-top">
            {this.state.logoSrc ? (
              <img src={this.state.logoSrc} alt="" />
            ) : (
              <span />
            )}
            <img src={require('../../assets/images/wgs-logo.png')} alt="" />
          </div>
          <div className="reset--right-bottom">
            <div>
              <div className="reset--title">{t('reset.title')}</div>
              <ResetForm
                translations={{
                  password: t('reset.password'),
                  confirmPassword: t('reset.confirmPassword'),
                  confirm: t('reset.confirm')
                }}
                onSubmit={this.submit.bind(this)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    reset: (email, resetToken, password, confirmPassword) =>
      dispatch(reset(email, resetToken, password, confirmPassword))
  };
}

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(withTranslation()(Reset))
);
